<template>
  <div class="d-flex justify-center">
    <!-- <v-container fluid>
      <v-row>
        <v-col sm="2" v-for="(queryKey, index) in queryKeys" :key="index"> -->
    <template v-for="(queryKey, index) in queryKeys">
      <v-switch
        class="mx-3"
        :key="index"
        :false-value="'false'"
        :true-value="'true'"
        :label="$t(`labels.${queryKey}`)"
        v-model="queries.query[queryKey]"
        @change="hadnleFitler(queryKey)"
      ></v-switch>
    </template>
    <!-- </v-col> -->
    <!-- <v-col sm="12">
        <v-btn @click="ClearFilter" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col> -->
    <!-- </v-row>
    </v-container> -->
  </div>
</template>

<script>
export default {
  name: "GlobalToggleFilter",
  props: {
    queries: {
      type: Object,
      default: () => {}
    },
    ClearAllFilters: {
      type: Function,
      default: function() {}
    }
  },
  computed: {
    queryKeys() {
      return Object.keys(this.queries.query);
    }
  },
  methods: {
    hadnleFitler(queryKey) {
      let query = {};

      let routeQuery = { ...this.$route.query };
      query[queryKey] = this.queries.query[queryKey];
      if (routeQuery.page > 1) {
        routeQuery.page = routeQuery.page - 1;
      }
      query = { ...routeQuery, ...query };
      if (this.queries.query[queryKey] === "false") {
        delete query[queryKey];
      }
      this.$router.push({ query });
    },
    ClearFilter() {
      const newQueryies = { ...this.$route.query };
      Object.keys(newQueryies).forEach(item => {
        if (this.queryKeys.includes(item)) {
          delete newQueryies[item];
          this.queries.query[item] = "";
        }
      });
      this.$router.push({ query: newQueryies });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        let queries = { ...query };
        const formQueries = Object.keys(this.queries.query);
        Object.keys(queries).forEach(keyQuery => {
          if (formQueries.includes(keyQuery)) {
            this.queries.query[keyQuery] = query[keyQuery];
          }
        });
      },
      immediate: true
    }
  }
};
</script>
